export enum ClientStatus {
    Suspend = 'SUSPEND',
    Active = 'ACTIVE',
}
